export default __webpack_public_path__ + "static/media/arrow-right.ebd842eb.svg";